import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { httpClient } from "../../utils/apiCall";
import { handleApiError } from "../../utils/apiError";
import { API_ENDPOINTS } from '../../config/api';
// Generated API'den import edilecek
// import { Api, type ItemCategoryDto, type ItemCategoryListParams } from '../../generated';

// Bu dosya generated API ile değiştirilecek
// Şimdilik mevcut interface'leri kullanıyoruz

// ItemCategory interfaces (Swagger'dan gelen bilgilere göre)
export interface ItemCategoryDto {
  id?: number;
  code?: string | null;
  name?: string | null;
  description?: string | null;
  isActive?: boolean;
  createdBy?: number;
  createdAt?: Date;
  updatedBy?: number | null;
  updatedAt?: Date | null;
}

export interface ItemCategoryListParams {
  Code?: string;
  Name?: string;
}

export interface ItemCategoryListResponse {
  success: boolean;
  message: string;
  data: {
    index: number;
    size: number;
    count: number;
    pages: number;
    hasPrevious: boolean;
    hasNext: boolean;
    items: ItemCategoryDto[];
  };
  errors: string[];
  traceId: string | null;
}

export interface ItemCategoryDetailResponse {
  success: boolean;
  message: string;
  data: ItemCategoryDto;
  errors: string[];
  traceId: string | null;
}

export interface ItemCategoryCreateResponse {
  success: boolean;
  message: string;
  data: ItemCategoryDto;
  errors: string[];
  traceId: string | null;
}

export interface ItemCategoryUpdateResponse {
  success: boolean;
  message: string;
  data: ItemCategoryDto;
  errors: string[];
  traceId: string | null;
}

export interface ItemCategoryDeleteResponse {
  success: boolean;
  message: string;
  data: any;
  errors: string[];
  traceId: string | null;
}

interface ItemCategoryState {
  loading: boolean;
  categories: ItemCategoryDto[];
  selectedCategory: ItemCategoryDto | null;
  error: string | null;
  filters: {
    code: string;
    name: string;
  };
}

const initialState: ItemCategoryState = {
  loading: false,
  categories: [],
  selectedCategory: null,
  error: null,
  filters: {
    code: '',
    name: '',
  },
};

// Generated API kullanımı için örnek async thunk'lar
// Bu thunk'lar generated API ile değiştirilecek

export const getItemCategories = createAsyncThunk(
  "itemCategory/getItemCategories",
  async (params: ItemCategoryListParams = {}, thunkAPI) => {
    try {
      // Query parameters oluştur
      const queryParams = new URLSearchParams();
      if (params.Code) queryParams.append('Code', params.Code);
      if (params.Name) queryParams.append('Name', params.Name);
      
      const apiUrl = `${API_ENDPOINTS.ITEM_CATEGORY.LIST}?${queryParams.toString()}`;
      
      const response = await httpClient.get<ItemCategoryListResponse['data']>(apiUrl);
      
      // Response validation
      if (!response.success) {
        throw new Error(response.message || 'API request failed');
      }
      
      // API'den gelen format: response.data direkt array
      if (!response.data || !Array.isArray(response.data)) {
        throw new Error('Invalid response format: missing data or data is not array');
      }
      
      // Expected format'a çevir
      const formattedResponse = {
        ...response,
        data: {
          items: response.data,
          index: 0,
          size: response.data.length,
          count: response.data.length,
          pages: 1,
          hasPrevious: false,
          hasNext: false
        }
      };
      
      return formattedResponse;
    } catch (error) {
      console.error('getItemCategories error:', error);
      return thunkAPI.rejectWithValue(handleApiError(error, 'Kategoriler yüklenemedi'));
    }
  }
);

export const getItemCategoryById = createAsyncThunk(
  "itemCategory/getItemCategoryById",
  async (id: number, thunkAPI) => {
    console.log('getItemCategoryById async thunk başladı!');
    try {
      console.log('Category ID:', id);
      
      const apiUrl = `${API_ENDPOINTS.ITEM_CATEGORY.DETAIL}/${id}`;
      console.log('API URL:', apiUrl);
      
      console.log('httpClient.get çağrılıyor...');
      const response = await httpClient.get<ItemCategoryDto>(apiUrl);
      console.log('httpClient response:', response);
      
      // Response validation
      if (!response.success) {
        console.log('Response success false:', response.message);
        throw new Error(response.message || 'API request failed');
      }
      
      if (!response.data) {
        console.log('Response data eksik:', response);
        throw new Error('Invalid response format: missing category data');
      }
      
      console.log('Response validation başarılı, data döndürülüyor');
      return response;
    } catch (error) {
      console.error('getItemCategoryById error:', error);
      return thunkAPI.rejectWithValue(handleApiError(error, 'Kategori detayları yüklenemedi'));
    }
  }
);

export const createItemCategory = createAsyncThunk(
  "itemCategory/createItemCategory",
  async (categoryData: ItemCategoryDto, thunkAPI) => {
    console.log('createItemCategory async thunk başladı!');
    try {
      console.log('Category data:', categoryData);
      
      const apiUrl = API_ENDPOINTS.ITEM_CATEGORY.CREATE;
      console.log('API URL:', apiUrl);
      
      console.log('httpClient.post çağrılıyor...');
      const response = await httpClient.post<ItemCategoryDto>(apiUrl, categoryData);
      console.log('httpClient response:', response);
      
      // Response validation
      if (!response.success) {
        console.log('Response success false:', response.message);
        throw new Error(response.message || 'API request failed');
      }
      
      if (!response.data) {
        console.log('Response data eksik:', response);
        throw new Error('Invalid response format: missing category data');
      }
      
      console.log('Response validation başarılı, data döndürülüyor');
      return response;
    } catch (error) {
      console.error('createItemCategory error:', error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateItemCategory = createAsyncThunk(
  "itemCategory/updateItemCategory",
  async ({ id, categoryData }: { id: number; categoryData: Partial<ItemCategoryDto> }, thunkAPI) => {
    console.log('updateItemCategory async thunk başladı!');
    try {
      console.log('Category ID:', id, 'Category data:', categoryData);
      
      const apiUrl = `${API_ENDPOINTS.ITEM_CATEGORY.UPDATE}/${id}`;
      console.log('API URL:', apiUrl);
      
      console.log('httpClient.put çağrılıyor...');
      const response = await httpClient.put<ItemCategoryDto>(apiUrl, categoryData);
      console.log('httpClient response:', response);
      
      // Response validation
      if (!response.success) {
        console.log('Response success false:', response.message);
        throw new Error(response.message || 'API request failed');
      }
      
      if (!response.data) {
        console.log('Response data eksik:', response);
        throw new Error('Invalid response format: missing category data');
      }
      
      console.log('Response validation başarılı, data döndürülüyor');
      return response;
    } catch (error) {
      console.error('updateItemCategory error:', error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteItemCategory = createAsyncThunk(
  "itemCategory/deleteItemCategory",
  async (id: number, thunkAPI) => {
    console.log('deleteItemCategory async thunk başladı!');
    try {
      console.log('Category ID:', id);
      
      const apiUrl = `${API_ENDPOINTS.ITEM_CATEGORY.DELETE}/${id}`;
      console.log('API URL:', apiUrl);
      
      console.log('httpClient.delete çağrılıyor...');
      const response = await httpClient.delete<any>(apiUrl);
      console.log('httpClient response:', response);
      
      // Response validation
      if (!response.success) {
        console.log('Response success false:', response.message);
        throw new Error(response.message || 'API request failed');
      }
      
      console.log('Response validation başarılı, data döndürülüyor');
      return { id, response };
    } catch (error) {
      console.error('deleteItemCategory error:', error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Generated API kullanımı için örnek:
/*
export const getItemCategories = createAsyncThunk(
  "itemCategory/getItemCategories",
  async (params: ItemCategoryListParams = {}, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await Api.itemCategoryList(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getItemCategoryById = createAsyncThunk(
  "itemCategory/getItemCategoryById",
  async (id: number, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await Api.itemCategoryDetail({ id });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createItemCategory = createAsyncThunk(
  "itemCategory/createItemCategory",
  async (categoryData: ItemCategoryDto, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await Api.itemCategoryCreate(categoryData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateItemCategory = createAsyncThunk(
  "itemCategory/updateItemCategory",
  async ({ id, categoryData }: { id: number; categoryData: Partial<ItemCategoryDto> }, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await Api.itemCategoryUpdate({ id }, categoryData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteItemCategory = createAsyncThunk(
  "itemCategory/deleteItemCategory",
  async (id: number, thunkAPI) => {
    try {
      // Generated API kullanımı
      const response = await Api.itemCategoryDelete({ id });
      return { id, response };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
*/

const itemCategorySlice = createSlice({
  name: "itemCategory",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCategories: (state) => {
      state.categories = [];
      state.error = null;
    },
    clearSelectedCategory: (state) => {
      state.selectedCategory = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        code: '',
        name: '',
      };
    },
  },
  extraReducers(builder) {
    // Get Item Categories
    builder.addCase(getItemCategories.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getItemCategories.fulfilled, (state, action) => {
      state.loading = false;
      state.categories = Array.isArray(action.payload.data?.items) ? action.payload.data.items : [];
      state.error = null;
    });
    builder.addCase(getItemCategories.rejected, (state, action) => {
      state.loading = false;
      // İptal edilen istekte payload null gelir; hata gösterilmez.
      state.error = (action.payload as string | null) ?? null;
    });

    // Get Item Category By ID
    builder.addCase(getItemCategoryById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getItemCategoryById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedCategory = action.payload.data;
      state.error = null;
    });
    builder.addCase(getItemCategoryById.rejected, (state, action) => {
      state.loading = false;
      // İptal edilen istekte payload null gelir; hata gösterilmez.
      state.error = (action.payload as string | null) ?? null;
    });

    // Create Item Category
    builder.addCase(createItemCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createItemCategory.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.data) {
        state.categories.push(action.payload.data);
      }
      state.error = null;
    });
    builder.addCase(createItemCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload instanceof Error 
        ? action.payload.message 
        : 'Kategori oluşturulamadı';
    });

    // Update Item Category
    builder.addCase(updateItemCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateItemCategory.fulfilled, (state, action) => {
      state.loading = false;
      const index = state.categories.findIndex(cat => cat.id === action.payload.data.id);
      if (index !== -1) {
        state.categories[index] = action.payload.data;
      }
      if (state.selectedCategory?.id === action.payload.data.id) {
        state.selectedCategory = action.payload.data;
      }
      state.error = null;
    });
    builder.addCase(updateItemCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload instanceof Error 
        ? action.payload.message 
        : 'Kategori güncellenemedi';
    });

    // Delete Item Category
    builder.addCase(deleteItemCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteItemCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.categories = state.categories.filter(cat => cat.id !== action.payload.id);
      if (state.selectedCategory?.id === action.payload.id) {
        state.selectedCategory = null;
      }
      state.error = null;
    });
    builder.addCase(deleteItemCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload instanceof Error 
        ? action.payload.message 
        : 'Kategori silinemedi';
    });
  },
});

export const { 
  clearError, 
  clearCategories, 
  clearSelectedCategory, 
  setFilters, 
  clearFilters 
} = itemCategorySlice.actions;
export default itemCategorySlice.reducer;
